<template>
  <div class="page">
    <PageHeader>
      Учет <i v-if="loading" class="el-icon-loading"></i>
    </PageHeader>
    <div class="content" v-if="loaded">
      <el-card
        shadow="always"
        :body-style="{ padding: '20px' }"
        v-loading="loading"
      >
        <div slot="header">
          <span>{{
            isEdit
              ? isClosed
                ? `Операция ${$route.params.id} закрыта`
                : `Редактируем операцию ${$route.params.id}`
              : "Новая операция"
          }}</span>
          <el-tooltip
            v-if="
              isClosed
              // && session.type <= -1
            "
            placement="top"
          >
            <div slot="content">
              <div>
                Открыть операцию
              </div>
              <div>
                Внимание!
              </div>
              <div>
                Статус "Закрыта" будет убран.
              </div>
              <div>
                Необходимо заново закрыть операцию.
              </div>
            </div>

            <el-button
              type="primary"
              icon="el-icon-unlock"
              @click="
                form.dateEnd = 'reopen';
                onEdit();
              "
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip v-if="isEdit && session.type <= -1" placement="top">
            <div slot="content">
              <div>
                Включить режим просмотра полной истории операции
              </div>
            </div>
            <el-switch
              v-model="isFullMode"
              active-text="Полный"
              inactive-text="Сокр."
            >
            </el-switch>
          </el-tooltip> -->
        </div>
        <!-- card body -->
        <el-form ref="form" :model="form" label-width="135px">
          <el-form-item v-if="!isEdit" label="Шаблон">
            <el-radio-group v-model="templateChosen">
              <el-radio-button
                v-for="template in exchangeTemplates.filter(
                  template =>
                    session.type <= template.template.level &&
                    template.type !== 'add-transaction'
                )"
                :label="template.type"
                :key="template.type"
              >
                {{ template.title }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>

          <div v-if="templateChosen || isEdit">
            <el-form-item v-if="form.isOpex" label="Категория" prop="category">
              <el-select v-model="form.category" filterable>
                <el-option
                  v-for="item in categories"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="!isEdit" label="Описание">
              <div class="description">
                {{
                  exchangeTemplates.find(t => t.type === templateChosen)
                    .description
                }}
              </div>
            </el-form-item>
            <el-form-item
              label="Открыта"
              prop="dateStart"
              :rules="validation.dateStart.rules"
            >
              <el-col :span="11">
                <el-date-picker
                  type="datetime"
                  placeholder="Pick a date"
                  v-model="form.dateStart"
                  style="width: 100%;"
                  :readonly="isEdit"
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item
              v-if="isClosed"
              label="Закрыта"
              prop="dateEnd"
              :rules="validation.dateEnd.rules"
            >
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="Pick a date"
                  v-model="form.dateEnd"
                  style="width: 100%;"
                  readonly
                ></el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item
              v-if="templateChosen !== 'internal' && !form.isInternal"
              label="Клиент"
              prop="userName"
              :rules="validation.userName.rules"
            >
              <el-autocomplete
                class="inline-input"
                v-model="form.userName"
                :fetch-suggestions="querySearchUserName"
                placeholder="Введите клиента"
                :trigger-on-focus="false"
                @select="handleSelect"
                :readonly="isEdit"
              ></el-autocomplete>
            </el-form-item>

            <el-form-item
              label="Тип"
              v-if="templateChosen !== 'internal' && !form.isInternal"
              prop="sourceType"
              :rules="validation.sourceType.rules"
            >
              <el-select
                v-model="form.sourceType"
                placeholder="Выберите тип"
                clearable
                :disabled="isEdit && session.type > -1"
              >
                <el-option
                  v-for="item in sourceTypes.docs"
                  :key="item.sourceType"
                  :label="item.title"
                  :value="item.sourceType"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="templateChosen !== 'internal' && !form.isInternal"
              label="Проект"
              prop="sourceChannel"
              :rules="validation.sourceChannel.rules"
            >
              <div v-if="form.sourceType">
                <el-select
                  v-model="form.sourceChannel"
                  :placeholder="sourceTypes['description']"
                  clearable
                  :disabled="isEdit && session.type > -1"
                >
                  <el-option
                    v-for="item in sourceProjects"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <div v-else>Выберите тип</div>
            </el-form-item>
            <el-form-item
              label="ID транзакции"
              v-if="
                (templateChosen === 'exchange' ||
                  (!form.isInternal &&
                    !form.isDeposit &&
                    !form.isCorrection &&
                    !form.isOpex &&
                    !form.isEmpty &&
                    !form.isReconciliation)) &&
                  ((form.sourceType === 'site' &&
                    form.sourceChannel === 'catbit') ||
                    (form.sourceType === 'api' &&
                      form.sourceChannel === 'catbitQiwiUsdtApi'))
              "
              prop="transactionId"
              :rules="validation.transactionId.rules"
              :required="
                (templateChosen === 'exchange' ||
                  (!form.isInternal &&
                    !form.isDeposit &&
                    !form.isCorrection &&
                    !form.isOpex &&
                    !form.isEmpty &&
                    !form.isReconciliation)) &&
                  ((form.sourceType === 'site' &&
                    form.sourceChannel === 'catbit') ||
                    (form.sourceType === 'api' &&
                      form.sourceChannel === 'catbitQiwiUsdtApi'))
              "
            >
              <input type="text" v-model="form.transactionId" />
            </el-form-item>
            <el-form-item label="Комментарий" prop="comment">
              <el-input
                type="textarea"
                placeholder="Введите комментарий"
                v-model="form.comment"
                maxlength="200"
                show-word-limit
              >
              </el-input>
            </el-form-item>
            <el-form-item
              v-if="templateChosen === 'exchange' || (isEdit && rate.outinRate)"
              label="Курсы"
            >
              <div v-if="!canGetRate.status">
                Курс не может быть получен. {{ canGetRate.message }}
              </div>
              <div v-else>
                <el-form-item
                  label-width="170px"
                  label="Курс биржевой"
                  size="normal"
                >
                  {{ numToString(rate.outinRate) }}
                  {{ rate.incode }} за 1 {{ rate.outcode }} |
                  {{ numToString(rate.inoutRate) }}
                  {{ rate.outcode }} за 1
                  {{ rate.incode }}
                  <span
                    >(получен
                    {{ $dayjs(rate.rateDate).format("DD.MM.YYYY HH:mm:ss") }})
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Курс сделки"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{ numToString(rateInternal.outinRate) }}
                    {{ rate.incode }} за 1 {{ rate.outcode }} |
                    {{ numToString(rateInternal.inoutRate) }}
                    {{ rate.outcode }} за 1 {{ rate.incode }}
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('rateInternalManual')()"
                      >Установить курс сделки вручную</el-button
                    >
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Разница монетарная"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{
                      numToString(
                        rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate,
                        5
                      )
                    }}
                    {{ rate.outcode }}
                    |
                    {{
                      numToString(
                        (rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate) *
                          rate.outRateRub,
                        2
                      )
                    }}
                    RUB |
                    {{
                      numToString(
                        (rateInternal.inamount / rate.outinRate -
                          rateInternal.inamount / rateInternal.outinRate) *
                          rate.outRateUsd,
                        2
                      )
                    }}
                    USD
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('diffAmountManual')()"
                      >Установить разницу вручную</el-button
                    >
                  </span>
                </el-form-item>
                <el-form-item
                  label-width="170px"
                  label="Разница %"
                  size="normal"
                >
                  <span v-if="rateInternal.status">
                    {{
                      Math.round(
                        // ((1 - rate.outinRate / rateInternal.outinRate) * 100 +
                        (((rateInternal.outinRate - rate.outinRate) /
                          rate.outinRate) *
                          100 +
                          Number.EPSILON) *
                          100
                      ) / 100
                    }}%
                  </span>
                  <span v-else>
                    {{ rateInternal.message }}
                    <el-button
                      v-if="hasAtleastOneAmount"
                      type="text"
                      @click="openManualPrompt('diffPercentManual')()"
                      >Установить разницу вручную</el-button
                    >
                  </span>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isDeposit"
              label="Депозит?"
              prop="isDeposit"
            >
              <el-switch v-model="form.isDeposit" :disabled="isEdit">
              </el-switch>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isCorrection"
              label="Корректировка?"
              prop="isCorrection"
            >
              <el-switch v-model="form.isCorrection" :disabled="isEdit">
              </el-switch>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isOpex"
              label="Операционные расходы?"
              prop="isOpex"
            >
              <el-switch v-model="form.isOpex" :disabled="isEdit"> </el-switch>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isInternal"
              label="Движение средств?"
              prop="isInternal"
            >
              <el-switch v-model="form.isInternal" :disabled="isEdit">
              </el-switch>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isEmpty"
              label="Свободная форма?"
              prop="isEmpty"
            >
              <el-switch v-model="form.isEmpty" :disabled="isEdit"> </el-switch>
            </el-form-item>
            <el-form-item
              v-if="isEdit && form.isReconciliation"
              label="Реконсиляция?"
              prop="isReconciliation"
            >
              <el-switch v-model="form.isReconciliation" :disabled="true">
              </el-switch>
              <div class="reconciliation-locked-note">
                Создана автоматически при закрытии расхождения, недоступна
                для редактирования никому
              </div>
            </el-form-item>
            <el-card
              v-for="(transaction, index) in form.transactions"
              :key="index"
              shadow="always"
              :body-style="{ padding: '20px' }"
            >
              <div slot="header">
                <span>Транзакция {{ index + 1 }}</span>
                <el-tooltip
                  :content="
                    `ID: ${
                      transaction._id
                        ? transaction._id
                        : 'ID будет присвоен после сохранения'
                    }`
                  "
                  placement="top"
                  effect="light"
                >
                  <span class="transaction-date transaction-date-created"
                    ><i class="el-icon-info"></i>{{ transaction._id }}</span
                  >
                </el-tooltip>
                <!-- <el-tooltip
                  :content="
                    transaction.createdAt
                      ? `Транзакция создана ${$dayjs(
                          transaction.createdAt
                        ).format('DD.MM.YYYY HH:mm:ss')}`
                      : `Дата создания транзакции неизвестна`
                  "
                  placement="top"
                  effect="light"
                >
                  <span class="transaction-date transaction-date-created"
                    ><i class="el-icon-document-add"></i
                    >{{
                      transaction.createdAt
                        ? $dayjs(transaction.createdAt).format(
                            "DD.MM.YYYY HH:mm:ss"
                          )
                        : "N/A"
                    }}</span
                  >
                </el-tooltip> -->
                <el-tooltip
                  :content="
                    transaction.updatedAt
                      ? `Транзакция изменена ${transaction.creator &&
                          transaction.creator.login +
                            ' ' +
                            $dayjs(transaction.updatedAt).format(
                              'DD.MM.YYYY HH:mm:ss'
                            )}`
                      : `Дата изменения транзакции неизвестна`
                  "
                  placement="top"
                  effect="light"
                >
                  <span class="transaction-date transaction-date-updated"
                    ><i class="el-icon-edit"></i
                    >{{
                      transaction.updatedAt
                        ? $dayjs(transaction.updatedAt).format(
                            "DD.MM.YYYY HH:mm:ss"
                          )
                        : "N/A"
                    }}</span
                  ></el-tooltip
                >
                <el-tooltip
                  v-if="
                    !isClosed && !transaction.counted && !transaction.deleted
                  "
                  placement="top"
                >
                  <div slot="content">Удалить транзакцию</div>
                  <el-button
                    type="danger"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-delete"
                    @click="onRemoveTransaction(index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    !isClosed && transaction.counted
                    // && session.type <= -1
                  "
                  placement="top"
                >
                  <div slot="content">
                    Разблокировать транзакцию для редактирования
                  </div>
                  <el-button
                    type="primary"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-unlock"
                    @click="onUncountTransaction(index)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  v-if="
                    !isClosed && transaction.deleted
                    // && session.type <= -1
                  "
                  placement="top"
                >
                  <div slot="content">
                    Отменить удаление
                  </div>
                  <el-button
                    type="success"
                    style="float: right; padding: 3px 3px"
                    icon="el-icon-refresh-left"
                    @click="onRestoreTransaction(index)"
                  ></el-button>
                </el-tooltip>
              </div>
              <div class="trbody">
                <div class="trmain">
                  <el-form-item
                    label="Вид"
                    :prop="'transactions.' + index + '.direction'"
                    :rules="
                      transaction.deleted ? [] : validation.direction.rules
                    "
                  >
                    <el-radio-group
                      v-model="form.transactions[index].direction"
                      @change="onDirectionChange(index)"
                      :disabled="transaction.counted"
                    >
                      <el-radio label="in">Входящая</el-radio>
                      <el-radio label="out">Исходящая</el-radio>
                      <el-radio label="deposit_out" :disabled="!form.isDeposit"
                        >Депозит</el-radio
                      >
                      <el-radio label="deposit_in" :disabled="!form.isDeposit"
                        >Возврат депозита</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item
                    label="Заморожена?"
                    :prop="'transactions.' + index + '.suspended'"
                    :rules="validation.suspended.rules"
                    v-if="['out', 'in'].includes(transaction.direction)"
                  >
                    <el-switch
                      :disabled="transaction.counted"
                      v-model="form.transactions[index].suspended"
                    >
                    </el-switch>
                  </el-form-item>
                  <el-form-item
                    v-if="
                      isDepositOut(index) &&
                        (!isEdit ||
                          !balanceAccountsOptions({ transaction, index })
                            .length)
                    "
                    label="Валюта"
                    :prop="'transactions.' + index + '.valute'"
                    :rules="transaction.deleted ? [] : validation.valute.rules"
                  >
                    <el-select
                      v-model="form.transactions[index].valute"
                      filterable
                      :loading="!valutes.length"
                      :disabled="
                        transaction.counted ||
                          (isEdit && !transaction.counted && !transaction.new)
                      "
                    >
                      <el-option
                        v-for="item in valutesOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    label="Баланс"
                    v-if="
                      isDepositOut(index) &&
                        (!isEdit ||
                          !balanceAccountsOptions({ transaction, index })
                            .length)
                    "
                  >
                    <div>
                      Для транзакции вида "Депозит" баланс будет создан при
                      сохранении обмена. Пожалуйста заполните эту транзакцию и
                      нажмите "<span v-if="isEdit">Сохранить операцию</span
                      ><span v-else>Создать операцию</span> и зафиксировать
                      депозит".
                    </div>
                  </el-form-item>

                  <el-form-item
                    v-else
                    label="Баланс"
                    :prop="'transactions.' + index + '.balanceAccount'"
                    :rules="
                      transaction.deleted ? [] : validation.balanceAccount.rules
                    "
                  >
                    <el-select
                      style="width: 460px;"
                      v-model="form.transactions[index].balanceAccount"
                      filterable
                      :loading="
                        !allBalanceAccounts.docs ||
                          !allBalanceAccounts.docs.length
                      "
                      :disabled="
                        transaction.counted ||
                          (isEdit && !transaction.counted && !transaction.new)
                      "
                      @change="handleBalanceAccountChange(index, $event)"
                    >
                      <!-- || isDepositOut(index) -->
                      <el-option
                        v-for="item in balanceAccountsOptions({
                          transaction,
                          index
                        })"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    :label="`Сумма`"
                    :prop="'transactions.' + index + '.amount'"
                    :rules="transaction.deleted ? [] : validation.amount.rules"
                  >
                    <el-input
                      style="width: 460px;"
                      v-model="form.transactions[index].amount"
                      @change="handleAmountChange(index, $event)"
                      :disabled="transaction.counted"
                    >
                      <i
                        v-if="isMinus(index)"
                        class="el-input__icon el-icon-minus"
                        slot="prefix"
                      ></i>
                      <i
                        v-else
                        class="el-input__icon el-icon-plus"
                        slot="prefix"
                      ></i>
                      <template
                        slot="suffix"
                        v-if="
                          getValuteNameFromBalanceAccountId(
                            form.transactions[index].balanceAccount
                          )
                        "
                        >{{
                          getValuteNameFromBalanceAccountId(
                            form.transactions[index].balanceAccount
                          )
                        }}</template
                      >
                    </el-input>

                    <!-- <el-input-number
                      style="width: 360px;"
                      v-model="form.transactions[index].amount"
                      :min="0"
                      :precision="12"
                      :controls="false"
                      @change="handleAmountChange(index, $event)"
                      :disabled="transaction.counted"
                    >
                    </el-input-number> -->
                  </el-form-item>
                  <el-card
                    shadow="always"
                    :body-style="{ padding: '20px' }"
                    v-if="isInOrOut(index)"
                  >
                    <el-form-item
                      label="Комиссия?"
                      :prop="'transactions.' + index + '.hasComission'"
                    >
                      <el-switch
                        :disabled="transaction.counted"
                        v-model="form.transactions[index].hasComission"
                      >
                      </el-switch>
                    </el-form-item>
                    <el-form-item
                      label="Сумма"
                      :prop="'transactions.' + index + '.comissionAmount'"
                      v-if="hasComission(index)"
                    >
                      <el-input-number
                        style="width: 360px;"
                        :disabled="transaction.counted"
                        v-model="form.transactions[index].comissionAmount"
                        :min="0"
                        :precision="12"
                        @change="handleComissionAmountChange(index, $event)"
                      ></el-input-number>
                    </el-form-item>
                    <el-form-item
                      label="Процент"
                      :prop="
                        'transactions.' + index + '.comissionAmountPercent'
                      "
                      v-if="hasComission(index)"
                    >
                      <el-input-number
                        style="width: 360px;"
                        :disabled="transaction.counted"
                        v-model="
                          form.transactions[index].comissionAmountPercent
                        "
                        :min="0"
                        :precision="4"
                        :step="0.1"
                        @change="
                          handleComissionAmountPercentChange(index, $event)
                        "
                      ></el-input-number>
                    </el-form-item>
                  </el-card>
                </div>
                <div v-if="transaction.deleted" class="troverlay">
                  <div>
                    Будет удалена!
                  </div>
                </div>
              </div>
            </el-card>
            <el-card shadow="always" :body-style="{ padding: '20px' }">
              <el-form-item v-if="showBottomButtons">
                <el-button
                  type="primary"
                  @click="onAddTransaction"
                  :disabled="
                    (hasDepositTransaction && !isEdit) ||
                      isClosed ||
                      form.isCorrection ||
                      form.isReconciliation
                  "
                  >Добавить транзакцию</el-button
                >
              </el-form-item>
              <el-form-item v-if="showBottomButtons">
                <template v-if="isEdit">
                  <el-button
                    v-if="
                      isClosed ||
                        form.isCorrection ||
                        form.isOpex ||
                        form.isReconciliation
                    "
                    disabled="disabled"
                    type="primary"
                    >{{
                      hasUncountedDepositTransaction
                        ? "Сохранить операцию и зафиксировать депозит"
                        : "Сохранить операцию"
                    }}</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет сохранена. Ее все еще можно редактировать"
                    @confirm="onEdit(false)"
                  >
                    <el-button slot="reference" type="primary">{{
                      hasUncountedDepositTransaction
                        ? "Сохранить операцию и зафиксировать депозит"
                        : "Сохранить операцию"
                    }}</el-button>
                  </el-popconfirm>
                  <el-button
                    v-if="
                      // !hasOutTransaction ||
                      ((isClosed || hasSuspendedTransaction) &&
                        !form.isCorrection &&
                        !form.isOpex) ||
                        form.isReconciliation
                    "
                    disabled="disabled"
                    type="primary"
                    >Сохранить и закрыть операцию</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет закрыта. Дальнейшие изменения возможны только с доступом суперадмина"
                    @confirm="onEdit(true)"
                  >
                    <el-button slot="reference" type="primary"
                      >Сохранить и закрыть операцию</el-button
                    >
                  </el-popconfirm>
                </template>
                <template v-else>
                  <el-button
                    v-if="isClosed || form.isCorrection || form.isOpex"
                    disabled="disabled"
                    type="primary"
                    >{{
                      hasDepositTransaction
                        ? "Создать операцию и зафиксировать депозит"
                        : "Создать операцию"
                    }}</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет создана. Ее все еще можно редактировать"
                    @confirm="onSubmit(false)"
                  >
                    <el-button slot="reference" type="primary">{{
                      hasDepositTransaction
                        ? "Создать операцию и зафиксировать депозит"
                        : "Создать операцию"
                    }}</el-button>
                  </el-popconfirm>
                  <el-button
                    v-if="
                      // !hasOutTransaction ||
                      hasSuspendedTransaction &&
                        !form.isCorrection &&
                        !form.isOpex
                    "
                    disabled="disabled"
                    type="primary"
                    >Создать и закрыть операцию</el-button
                  >
                  <el-popconfirm
                    v-else
                    title="Сделка будет закрыта. Дальнейшие изменения возможны только с доступом суперадмина"
                    @confirm="onSubmit(true)"
                  >
                    <el-button slot="reference" type="primary"
                      >Создать и закрыть операцию</el-button
                    >
                  </el-popconfirm>
                </template>
                <el-button @click="$router.push({ name: 'Ledger' })"
                  >Отмена</el-button
                >
              </el-form-item>
            </el-card>
          </div>
        </el-form>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import {
  getBalanceAccounts,
  getLedgerExchange,
  editLedgerExchange,
  getUsersSuggest,
  getLedgerValutes,
  getBinanceRate,
  getSourceTypes,
  getProjects
} from "@/api";

import exchangeTemplates from "./exchangeTemplates";
import validation from "./validation";
import fees from "./fees";
import categories from "./categories";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "LedgerAdd",
  data: () => ({
    form: {
      dateStart: new Date(),
      dateEnd: null,
      userName: "",
      isDeposit: false,
      isCorrection: false,
      isOpex: false,
      isInternal: false,
      isEmpty: false,
      isReconciliation: false,
      comment: "",
      level: 1,
      sourceType: "",
      sourceChannel: "",
      transactions: []
    },
    userSuggestions: [],
    transactionTemplate: {
      valute: "",
      amount: 0,
      direction: "in",
      balanceAccount: "",
      counted: false,
      hasComission: false,
      suspended: false
    },
    allBalanceAccounts: {},
    loading: true,
    loaded: false,
    isEdit: false,
    isClosed: false,
    showBottomButtons: false,
    exchangeTemplates,
    sourceTypes: [],
    templateChosen: null,
    ledgerValutes: [],
    rate: {},
    rateLoading: false,
    validation,
    fees,
    categories,
    sourceProjects: []
    // isFullMode: false
  }),
  computed: {
    ...mapState("valutes", ["valutes"]),
    // ...mapState("balanceAccounts", ["balanceAccounts"]),
    ...mapState("auth", ["session"]),
    sourceProjectsPlaceholder() {
      this.sourceTypes.docs.find(s => s.sourceType === form.sourceType)[
        "description"
      ];
      return selectedSourceType ? `Выберите проект` : "Выберите тип";
    },
    valutesOptions() {
      return this.ledgerValutes.map(valute => {
        return {
          value: valute._id,
          label: valute.name
        };
      });
    },
    balanceAccountsOptions() {
      return (t = {}) => {
        if (!this.allBalanceAccounts.docs) return [];
        return this.allBalanceAccounts.docs
          .map(balanceAccount => {
            return {
              value: balanceAccount._id,
              label: `${balanceAccount.title} - ${balanceAccount.balance} ${
                balanceAccount.valute ? balanceAccount.valute.name : ""
              }`
            };
          })
          .filter(option => {
            return (
              (t.transaction.direction !== "deposit_out" &&
                t.transaction.direction !== "deposit_in") ||
              this.form.transactions.find(
                tr =>
                  tr.balanceAccount === option.value &&
                  tr.direction === "deposit_out"
              )
            );
          });
      };
    },
    hasDepositTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction => transaction.direction === "deposit_out"
        ) !== -1
      );
    },
    hasUncountedDepositTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction =>
            transaction.direction === "deposit_out" && !transaction.counted
        ) !== -1
      );
    },
    hasOutTransaction() {
      return (
        this.form.transactions.findIndex(transaction =>
          ["deposit_in", "out"].includes(transaction.direction)
        ) !== -1
      );
    },
    hasSuspendedTransaction() {
      return (
        this.form.transactions.findIndex(
          transaction => transaction.suspended
        ) !== -1
      );
    },
    canGetRate() {
      this.form.rateFromExchanges = undefined;
      const intrans = this.form.transactions.find(
        tr => tr.direction === "in" || tr.direction === "alteration_in"
      );
      if (!intrans)
        return {
          status: false,
          message: `Нет входящих транзакций!`
        };

      const incode = this.getValuteNameFromBalanceAccountId(
        intrans.balanceAccount
      );
      if (!incode)
        return {
          status: false,
          message: `Во входящей транзакции не выбран баланс либо баланс без валюты!`
        };

      const outtrans = this.form.transactions.find(
        tr => tr.direction === "out" || tr.direction === "alteration_out"
      );
      if (!outtrans)
        return {
          status: false,
          message: `Нет исходящих транзакций!`
        };

      const outcode = this.getValuteNameFromBalanceAccountId(
        outtrans.balanceAccount
      );
      if (!outcode)
        return {
          status: false,
          message: `В исходящей транзакции не выбран баланс либо баланс без валюты!`
        };

      const uniqueValuteNames = this.form.transactions.reduce((prev, curr) => {
        const currCode = this.getValuteNameFromBalanceAccountId(
          curr.balanceAccount
        );
        if (!prev.includes(`${currCode}${curr.direction}`))
          return [...prev, `${currCode}${curr.direction}`];
        return [...prev];
      }, []);

      if (uniqueValuteNames.length > 2)
        return {
          status: false,
          message: `Валют больше двух, расчет невозможен`
        };

      return { status: true, incode, outcode };
    },
    rateInternal() {
      this.form.rateInternal = undefined;
      if (!this.canGetRate.status)
        return {
          status: false,
          message: `Валют больше двух, расчет невозможен`
        };

      const intranses = this.form.transactions.filter(
        tr => tr.direction === "in" || tr.direction === "alteration_in"
      );
      const inamount = intranses.reduce((prev, curr) => {
        return prev + curr.amount * 1;
      }, 0);
      if (!inamount)
        return {
          status: false,
          message: `Во входящей транзакции не введена сумма!`
        };

      const outtranses = this.form.transactions.filter(
        tr => tr.direction === "out" || tr.direction === "alteration_out"
      );
      const outamount = outtranses.reduce((prev, curr) => {
        return prev + curr.amount * 1;
      }, 0);
      if (!outamount)
        return {
          status: false,
          message: `В исходящей транзакции не введена сумма!`
        };

      this.form.rateInternal = {
        status: true,
        inamount,
        outamount,
        outinRate: inamount / outamount,
        inoutRate: outamount / inamount
      };
      return {
        status: true,
        inamount,
        outamount,
        outinRate: inamount / outamount,
        inoutRate: outamount / inamount
      };
    },
    hasAtleastOneAmount() {
      //this.form.rateInternal = undefined;
      const intrans = this.form.transactions.find(
        tr => tr.direction === "in" || tr.direction === "alteration_in"
      );
      const inamount = intrans.amount * 1;

      const outtrans = this.form.transactions.find(
        tr => tr.direction === "out" || tr.direction === "alteration_out"
      );
      const outamount = outtrans.amount * 1;
      return !!inamount || !!outamount;
    }
  },
  watch: {
    async canGetRate(curr, prev) {
      // console.log(prev, curr);
      if (curr.status && !this.isEdit) {
        await this.getRate();
      }
    },
    "form.sourceType": function(newVal, oldVal) {
      if (oldVal) this.form.sourceChannel = "";
    },
    "form.sourceChannel": function(newVal, oldVal) {
      if (oldVal) this.form.transactionId = "";
    },
    templateChosen() {
      const template = this.exchangeTemplates.find(
        template => template.type === this.templateChosen
      );
      if (template) {
        this.form.transactions = template.template.transactions.map(entry => {
          return { ...entry };
        });
        this.form.isDeposit = template.template.isDeposit;
        this.form.isCorrection = template.template.isCorrection;
        this.form.isOpex = template.template.isOpex;
        this.form.isInternal = template.template.isInternal;
        this.form.isEmpty = template.template.isEmpty;
        this.form.level = template.template.level;
        this.showBottomButtons = true;

        if (typeof this.$refs["form"] !== "undefined") {
          this.$refs["form"].clearValidate();
        }
      }
    }
  },
  methods: {
    ...mapActions("ledgerExchanges", ["addLedgerExchange"]),
    ...mapActions("valutes", ["getValutes", "getSortedValutes"]),
    async getSourceTypes() {
      try {
        this.loading = true;
        const { data } = await getSourceTypes();

        if (data.status) {
          this.sourceTypes = data.result;
          //console.log(this.sourceTypes.map((item) => { return item.projects.find(el => { return el._id === form.sourceType }) }))
        }
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    async getProjects() {
      try {
        this.loading = true;
        const { data } = await getProjects({ pagination: false });

        if (data.status) {
          this.sourceProjects = data.result.docs.filter(o => o.option === true);
          //console.log(this.sourceTypes.map((item) => { return item.projects.find(el => { return el._id === form.sourceType }) }))
        }
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    openManualPrompt(param) {
      const that = this;
      const opts = {
        rateInternalManual: {
          message: `Введите желаемый курс сделки в ${this.rate.incode} за 1 ${this.rate.outcode}`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        },
        diffAmountManual: {
          message: `Введите желаемую монетарную разницу в ${this.rate.outcode}`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        },
        diffPercentManual: {
          message: `Введите желаемую разницу в %`,
          title: "Ручной ввод",
          inputValidator: val =>
            Number.isFinite(val * 1) ? true : "Введите число!"
        }
      };
      return () => {
        that
          .$prompt(opts[param].message, opts[param].title, {
            confirmButtonText: "OK",
            cancelButtonText: "Отмена",
            inputValidator: opts[param].inputValidator
          })
          .then(({ value }) => {
            const mess = that.setManualValue(param)(value * 1);
            that.$message({
              type: "success",
              message: mess
            });
          })
          .catch(() => {
            that.$message({
              type: "info",
              message: "Ввод отменен"
            });
          });
      };
    },
    setManualValue(param) {
      const that = this;
      return val => {
        const intrans = that.form.transactions.find(
          tr => tr.direction === "in"
        );
        const inamount = intrans.amount * 1;
        const outtrans = that.form.transactions.find(
          tr => tr.direction === "out"
        );
        const outamount = outtrans.amount * 1;

        if (!inamount) {
          if (param === "rateInternalManual") intrans.amount = outamount * val;
          if (param === "diffAmountManual")
            intrans.amount = (val + outamount) / (1 / that.rate.outinRate);
          if (param === "diffPercentManual")
            intrans.amount =
              ((1 + val / 100) * outamount) / (1 / that.rate.outinRate);
          return "Сумма во входящей транзакции обновлена";
        }

        if (!outamount) {
          if (param === "rateInternalManual") outtrans.amount = inamount / val;
          if (param === "diffAmountManual")
            outtrans.amount = inamount / that.rate.outinRate - val;
          if (param === "diffPercentManual")
            outtrans.amount = inamount / that.rate.outinRate / (1 + val / 100);
          return "Сумма в исходящей транзакции обновлена";
        }
      };
    },
    // setRateInternal(val) {
    //   const intrans = this.form.transactions.find(tr => tr.direction === "in");
    //   const inamount = intrans.amount * 1;
    //   const outtrans = this.form.transactions.find(
    //     tr => tr.direction === "out"
    //   );
    //   const outamount = outtrans.amount * 1;

    //   if (!inamount) {
    //     intrans.amount = outamount * val;
    //   }
    //   if (!outamount) {
    //     outtrans.amount = inamount / val;
    //   }
    // },
    // setDiffAmount(val) {
    //   const intrans = this.form.transactions.find(tr => tr.direction === "in");
    //   const inamount = intrans.amount * 1;
    //   const outtrans = this.form.transactions.find(
    //     tr => tr.direction === "out"
    //   );
    //   const outamount = outtrans.amount * 1;

    //   if (!inamount) {
    //     intrans.amount = (val + outamount) / (1 / this.rate.outinRate);
    //   }
    //   if (!outamount) {
    //     outtrans.amount = inamount / this.rate.outinRate - val;
    //   }
    // },
    // setDiffPercent(val) {
    //   const intrans = this.form.transactions.find(tr => tr.direction === "in");
    //   const inamount = intrans.amount * 1;
    //   const outtrans = this.form.transactions.find(
    //     tr => tr.direction === "out"
    //   );
    //   const outamount = outtrans.amount * 1;

    //   if (!inamount) {
    //     intrans.amount =
    //       ((1 + val / 100) * outamount) / (1 / this.rate.outinRate);
    //   }
    //   if (!outamount) {
    //     outtrans.amount = inamount / this.rate.outinRate / (1 + val / 100);
    //   }
    // },

    getValuteNameFromBalanceAccountId(id) {
      if (!id || !this.allBalanceAccounts.docs) return null;
      const ba = this.allBalanceAccounts.docs.find(b => b._id === id);
      if (!ba) return null;
      return ba.valute && ba.valute.name;
    },
    async getRate() {
      this.rate = {};
      this.form.rateFromExchanges = undefined;
      if (!this.canGetRate.status)
        return this.$message({
          type: "error",
          message: this.canGetRate.message
        });
      try {
        this.rateLoading = true;
        const { data } = await getBinanceRate(
          this.canGetRate.incode,
          this.canGetRate.outcode
        );
        this.rate = {
          ...data.result,
          rateDate: new Date()
        };
        this.form.rateFromExchanges = { ...this.rate };
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      } finally {
        this.rateLoading = false;
      }
    },
    isDepositOut(index) {
      return this.form.transactions[index].direction === "deposit_out";
    },
    isInOrOut(index) {
      return (
        this.form.transactions[index].direction === "out" ||
        this.form.transactions[index].direction === "in" ||
        this.form.transactions[index].direction === "alteration_out" ||
        this.form.transactions[index].direction === "alteration_in"
      );
    },
    hasComission(index) {
      return this.form.transactions[index].hasComission;
    },
    isMinus(index) {
      return ["deposit_out", "out", "alteration_out"].includes(
        this.form.transactions[index].direction
      );
    },
    // *************************************
    //this function is fucked up, it's not used for now
    calculateTransactionAmounts({
      amount,
      comissionAmount,
      comissionAmountPercent
    }) {
      const parsedAmount = parseFloat(parseFloat(amount).toFixed(12));
      const parsedComissionAmount = parseFloat(
        parseFloat(comissionAmount).toFixed(12)
      );
      const parsedComissionAmountPercent = parseFloat(
        parseFloat(comissionAmountPercent).toFixed(4)
      );
      //amount is missed or malformed
      if (
        parsedAmount === NaN &&
        parsedComissionAmount !== NaN &&
        parsedComissionAmountPercent !== NaN
      ) {
        return {
          amount: parseFloat(
            (
              (parsedComissionAmount * 100) /
              parsedComissionAmountPercent
            ).toFixed(12)
          ),
          comissionAmount: parsedComissionAmount,
          comissionAmountPercent: parsedComissionAmountPercent
        };
      }
      //comission amount is missed or malformed
      if (
        parsedAmount !== NaN &&
        parsedComissionAmount === NaN &&
        parsedComissionAmountPercent !== NaN
      ) {
        return {
          amount: parsedAmount,
          comissionAmount: parseFloat(
            ((parsedAmount * parsedComissionAmountPercent) / 100).toFixed(12)
          ),
          comissionAmountPercent: parsedComissionAmountPercent
        };
      }
      //comission amount percent is missed or malformed
      if (
        parsedAmount !== NaN &&
        parsedComissionAmount === NaN &&
        parsedComissionAmountPercent !== NaN
      ) {
        return {
          amount: parsedAmount,
          comissionAmount: parsedComissionAmount,
          comissionAmountPercent: parseFloat(
            ((parsedComissionAmount / parsedAmount) * 100).toFixed(4)
          )
        };
      }

      //more than two inputs are missed or malformed
      return {
        amount: NaN,
        comissionAmount: NaN,
        comissionAmountPercent: NaN
      };
    },
    handleComissionAmountChange(index, val) {
      const parsedVal = parseFloat((val ? val : 0).toFixed(12));
      const calculatedPercent = parseFloat(
        (this.form.transactions[index].amount
          ? (parsedVal / this.form.transactions[index].amount) * 100
          : 0
        ).toFixed(4)
      );
      this.form.transactions[index].comissionAmount = parsedVal;
      this.form.transactions[index].comissionAmountPercent = calculatedPercent;
    },
    handleComissionAmountPercentChange(index, val) {
      const parsedVal = parseFloat((val ? val : 0).toFixed(4));
      const calculatedAmount = parseFloat(
        ((parsedVal / 100) * this.form.transactions[index].amount).toFixed(12)
      );
      this.form.transactions[index].comissionAmountPercent = parsedVal;
      this.form.transactions[index].comissionAmount = calculatedAmount;
    },
    handleAmountChange(index, val) {
      const parsedVal = parseFloat(parseFloat(val).toFixed(12));
      this.form.transactions[index].amount = parsedVal;
      if (!this.form.transactions[index].hasComission) return;
      if (!parsedVal) {
        this.form.transactions[index].comissionAmountPercent = 0;
        return;
      }
      if (this.form.transactions[index].comissionAmount) {
        const calculatedPercent = parseFloat(
          (
            (this.form.transactions[index].comissionAmount / parsedVal) *
            100
          ).toFixed(4)
        );
        // const calculatedAmount = parseFloat(
        //   ((calculatedPercent / 100) * parsedVal).toFixed(12)
        // );
        this.form.transactions[
          index
        ].comissionAmountPercent = calculatedPercent;
        // this.form.transactions[index].comissionAmount = calculatedAmount;
        return;
      }
      if (this.form.transactions[index].comissionAmountPercent) {
        const calculatedAmount = parseFloat(
          (
            (this.form.transactions[index].comissionAmountPercent / 100) *
            parsedVal
          ).toFixed(12)
        );
        // const calculatedPercent = parseFloat(
        //   ((calculatedAmount / parsedVal) * 100).toFixed(4)
        // );
        this.form.transactions[index].comissionAmount = calculatedAmount;
        // this.form.transactions[
        //   index
        // ].comissionAmountPercent = calculatedPercent;
      }
    },
    handleBalanceAccountChange(index, val) {
      const bafull = this.allBalanceAccounts.docs.find(ba => ba._id === val);
      if (!bafull) return;
      const fee =
        bafull.valute && bafull.valute.name
          ? this.fees.find(
              f => f.name.toLowerCase() === bafull.valute.name.toLowerCase()
            )
          : null;
      if (!fee) return;
      const balanceFee = bafull.type ? fee[bafull.type] : null;
      if (!balanceFee) return;
      const directionFee = this.form.transactions[index].direction
        ? balanceFee[this.form.transactions[index].direction]
        : null;
      if (!directionFee) return;
      this.form.transactions[index].hasComission = true;
      if (directionFee.comissionAmount) {
        this.form.transactions[index].comissionAmount = parseFloat(
          parseFloat(directionFee.comissionAmount).toFixed(12)
        );
        // this.handleComissionAmountChange(index, directionFee.comissionAmount);
        return;
      }
      if (directionFee.comissionAmountPercent) {
        this.form.transactions[index].comissionAmountPercent = parseFloat(
          parseFloat(directionFee.comissionAmountPercent).toFixed(4)
        );
        // this.handleComissionAmountPercentChange(
        //   index,
        //   directionFee.comissionAmountPercent
        // );
        return;
      }
    },
    // **********************************
    async onSubmit(isClosed = false) {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (isClosed) this.form.dateEnd = new Date();
          if (!this.session._id) return alert("Ошибка определения оператора!");
          if (this.templateChosen === "internal") {
            this.form.userName = this.session.login;
            this.form.sourceType = "site";
            this.form.sourceChannel = "catbit";
          }
          const data = {
            ...this.form,
            ledgerTransactions: this.form.transactions,
            creator: this.session._id
            // dateStart: this.form.dateStart,
            // dateEnd: this.form.dateEnd,
            // userName: this.form.userName,
            // comment: this.form.comment,
            // isDeposit: this.form.isDeposit
          };
          // try {
          this.loading = true;
          const resp = await this.addLedgerExchange(data);
          console.log(resp);
          // if (!resp.status || !resp.result._id) throw new Error(resp);
          if (!resp.status || !resp.result._id) {
            const errMessage =
              resp.error &&
              resp.error.response &&
              resp.error.response.data &&
              resp.error.response.data.message
                ? resp.error.response.data.message
                : "Что-то пошло не так!";
            this.$message({
              type: "error",
              message: errMessage
            });
            this.loading = false;
            return false;
          }
          this.$confirm(
            `Операция прошла успешно, вернуться к списку?`,
            "Успех",
            {
              confirmButtonText: "Вернуться",
              cancelButtonText: "Остаться",
              type: "success"
            }
          )
            .then(() => {
              this.$router.push({ name: "Ledger" });
            })
            .catch(async () => {
              this.$router.push({
                name: "LedgerEdit",
                params: { id: resp.result._id }
              });
              await this.onMount();
            });
          // } catch (error) {
          //   console.log(JSON.stringify(error));
          //   this.$message({ type: "error", message: "Что-то пошло не так!" });
          // } finally {
          this.loading = false;
          // }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
          return false;
        }
      });
    },
    async onEdit(isClosed = false) {
      this.$refs["form"].validate(async valid => {
        if (valid) {
          if (isClosed) this.form.dateEnd = new Date();
          if (!this.session._id) return alert("Ошибка определения оператора!");
          const data = {
            ...this.form,
            ledgerTransactions: this.form.transactions,
            creator: this.session._id
            // dateStart: this.form.dateStart,
            // dateEnd: this.form.dateEnd,
            // userName: this.form.userName,
            // comment: this.form.comment,
            // isDeposit: this.form.isDeposit
          };
          try {
            this.loading = true;
            const resp = await editLedgerExchange(this.$route.params.id, data);
            if (!resp.data || !resp.data.status || !resp.data.result._id)
              throw new Error("Что-то пошло не так!");
            this.$confirm(
              `Операция прошла успешно, вернуться к списку?`,
              "Успех",
              {
                confirmButtonText: "Вернуться",
                cancelButtonText: "Остаться",
                type: "success"
              }
            )
              .then(() => {
                this.$router.push({ name: "Ledger" });
              })
              .catch(async () => {
                // this.$router.push({
                //   name: "LedgerEdit",
                //   params: { id: resp.data.result._id }
                // });
                await this.onMount();
              });
            // if (this.form.dateEnd === "reopen") await this.onMount();
            // else this.$router.push({ name: "Ledger" });
          } catch (error) {
            const errMessage =
              error &&
              error.response &&
              error.response.data &&
              error.response.data.message
                ? error.response.data.message
                : "Что-то пошло не так! Попробуйте еще раз!";
            this.$message({
              type: "error",
              message: errMessage
            });
            // this.$message({
            //   type: "error",
            //   message: "Что-то пошло не так! Попробуйте еще раз!"
            // });
          } finally {
            this.loading = false;
          }
        } else {
          this.$message({
            type: "error",
            message: "Ошибка при заполнении формы!"
          });
          return false;
        }
      });
    },
    clearFieldsValidation(fields) {
      this.$refs["form"].clearValidate(fields);
    },
    onAddTransaction() {
      this.form.transactions = [
        ...this.form.transactions,
        { ...this.transactionTemplate, new: true }
      ];
    },
    onRemoveTransaction(index) {
      this.form.transactions = this.form.transactions
        .map((transaction, i) => {
          return i !== index
            ? { ...transaction }
            : transaction.edited
            ? { ...transaction, counted: false, deleted: true }
            : { ...transaction };
        })
        .filter((transaction, i) => {
          return i !== index || transaction.edited;
        });
      this.$refs["form"].clearValidate();
    },
    onRestoreTransaction(index) {
      this.form.transactions = this.form.transactions.map((transaction, i) => {
        return i !== index
          ? { ...transaction }
          : transaction.deleted
          ? { ...transaction, counted: false, deleted: false }
          : { ...transaction };
      });
    },
    onUncountTransaction(index) {
      this.form.transactions = this.form.transactions.map((transaction, i) => {
        return i !== index
          ? { ...transaction }
          : { ...transaction, counted: false, edited: true };
      });
    },
    async loadTransaction() {
      const loadedExchange = await getLedgerExchange(this.$route.params.id);
      if (loadedExchange.data.status) {
        this.form = {
          ...loadedExchange.data.result,
          transactions: loadedExchange.data.result.ledgerTransactions
            .filter(item => !item.isHidden && !item.isRevert)
            .map(transaction => {
              return {
                ...transaction,
                hasComission: !!transaction.comissionAmount,
                comissionAmount: !!transaction.comissionAmount
                  ? transaction.comissionAmount
                  : 0,
                comissionAmountPercent:
                  !!transaction.comissionAmount && !!transaction.amount
                    ? (transaction.comissionAmount / transaction.amount) * 100
                    : 0
              };
            })
        };
        if (this.form.rateFromExchanges) {
          this.rate = {
            ...this.form.rateFromExchanges
          };
        }
      }
    },
    onDirectionChange(index) {
      this.clearFieldsValidation([
        "transactions." + index + ".direction",
        "transactions." + index + ".valute",
        "transactions." + index + ".balanceAccount",
        "transactions." + index + ".amount"
      ]);
    },
    async querySearchUserName(queryString, cb) {
      const resp = await getUsersSuggest(queryString);
      const results = resp.data.result.map(user => {
        return {
          value: user.login
        };
      });
      cb(results);
    },
    handleSelect(item) {
      console.log(item);
    },
    async onMount() {
      if (this.$route.params.id) {
        this.isEdit = true;
        this.showBottomButtons = true;
        this.loading = true;
        await this.loadTransaction();
        this.isClosed = this.form.dateEnd ? true : false;
      }
      const query = {
        isDeleted: { $ne: true }
      };
      const resp = await getBalanceAccounts({ pagination: false, query });
      if (resp.data.status) this.allBalanceAccounts = resp.data.result;
      // if (!this.valutes.length) await this.getSortedValutes();
      const valutesResp = await getLedgerValutes({ pagination: false });
      if (valutesResp.data.status)
        this.ledgerValutes = valutesResp.data.result.docs;
      this.loading = false;
    }
  },
  beforeMount() {},
  async mounted() {
    await this.onMount(), this.getSourceTypes(), this.getProjects();
    this.loaded = true;
  }
};
</script>
<style scoped>
.reconciliation-locked-note {
  color: #909399;
  font-size: 0.85rem;
  margin-top: 4px;
}
.trbody {
  position: relative;
  /* width: 100%; */
  /* height: 100%; */
}
.trbody .trmain {
  /* position: absolute; */
}
.trbody .troverlay {
  position: absolute;
  background-color: rgba(245, 108, 108, 0.7);
  width: 100%;
  height: 100%;
  z-index: 2;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trbody .troverlay div {
  font-size: 2rem;
  color: #fff;
}

.transaction-date {
  color: #aaa;
  margin-left: 1rem;
  font-size: 0.85rem;
}
.transaction-date i {
  margin-right: 5px;
  color: hsl(210, 50%, 63%);
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/add.vue